import { render, staticRenderFns } from "./DataSync.vue?vue&type=template&id=762443fe&scoped=true"
import script from "./DataSync.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSync.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataSync.vue?vue&type=style&index=0&id=762443fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762443fe",
  null
  
)

export default component.exports